module.exports = __webpack_public_path__ + "static/media/2.b87ee8e2.JPG";